import React from "react";
import { ManageSourcesNewContainer } from "../../../containers";

const ManageSourcesNew = (props) => {
  return <ManageSourcesNewContainer {...props} />;
};

export default ManageSourcesNew;
